import React, { useState } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Timeline } from './Timeline';
import { LayerControl } from './LayerControl';
import { ConvoyLayer } from './ConvoyLayer';
import { BulkFuelLayer } from './BulkFuelLayer';
import { MunitionsLayer } from './MunitionsLayer';
import { SubsistenceLayer } from './SubsistenceLayer';
import { MaintenanceLayer } from './MaintenanceLayer';
import { CombatSlantLayer } from './CombatSlantLayer';
import { MedicalSupportLayer } from './MedicalSupportLayer';
import { PriorityOfSupport } from './PriorityOfSupport';
export const MapView = () => {
  // Center coordinates to show the entire route
  const centerCoordinates: [number, number] = [28.5, -101.0];
  const defaultZoom = 6;
  const [selectedTimePoint, setSelectedTimePoint] = useState('now');
  const [mapLayers, setMapLayers] = useState([{
    id: 'keyMovements',
    label: 'Key and Essential Movements',
    checked: true
  }, {
    id: 'bulkFuel',
    label: 'Bulk Fuel Nodes and Distribution Plans',
    checked: true
  }, {
    id: 'munitions',
    label: 'Critical Munitions Status and Distribution Plans',
    checked: true
  }, {
    id: 'subsistence',
    label: 'Class I Subsistence Nodes and Distribution Plans',
    checked: true
  }, {
    id: 'maintenance',
    label: 'Class VII Maintenance Status – 7-Day Forecast',
    checked: true
  }, {
    id: 'combatSlant',
    label: 'Combat Slant – Force Composition and Capability',
    checked: true
  }, {
    id: 'medicalSupport',
    label: 'Medical Support – Treatment Nodes and Capacity',
    checked: true
  }]);
  // Handle layer visibility changes
  const handleLayerChange = (layerId: string, checked: boolean) => {
    setMapLayers(prev => prev.map(layer => layer.id === layerId ? {
      ...layer,
      checked
    } : layer));
  };
  // Check if a layer is visible
  const isLayerVisible = (layerId: string) => {
    const layer = mapLayers.find(l => l.id === layerId);
    return layer ? layer.checked : false;
  };
  return <div className="flex flex-col" data-id="element-331">
      <div className="h-[600px] w-full relative flex" data-id="element-332">
        {/* Timeline on the left */}
        <div className="w-48 h-full border-r border-gray-200 bg-white" data-id="element-333">
          <Timeline selectedTimePoint={selectedTimePoint} onTimePointChange={setSelectedTimePoint} data-id="element-334" />
        </div>
        {/* Map container */}
        <div className="flex-1 h-full relative" data-id="element-335">
          <MapContainer center={centerCoordinates} zoom={defaultZoom} style={{
          height: '100%',
          width: '100%'
        }} data-id="element-336">
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' data-id="element-337" />
            {/* Render lower priority layers first */}
            {/* Bulk Fuel Layer */}
            {isLayerVisible('bulkFuel') && <BulkFuelLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-338" />}
            {/* Munitions Layer */}
            {isLayerVisible('munitions') && <MunitionsLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-339" />}
            {/* Subsistence Layer */}
            {isLayerVisible('subsistence') && <SubsistenceLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-340" />}
            {/* Maintenance Layer */}
            {isLayerVisible('maintenance') && <MaintenanceLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-341" />}
            {/* Combat Slant Layer */}
            {isLayerVisible('combatSlant') && <CombatSlantLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-342" />}
            {/* Render high priority layers last (they will appear on top) */}
            {/* Key and Essential Movements Layer (Convoy Layer) */}
            {isLayerVisible('keyMovements') && <ConvoyLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-343" />}
            {/* Medical Support Layer */}
            {isLayerVisible('medicalSupport') && <MedicalSupportLayer selectedTimePoint={selectedTimePoint} useAlternativeRoute={false} data-id="element-344" />}
          </MapContainer>
          {/* Layer Control */}
          <div className="absolute top-4 right-4 z-[1000]" data-id="element-345">
            <LayerControl layers={mapLayers} onLayerChange={handleLayerChange} data-id="element-346" />
          </div>
        </div>
      </div>
      {/* Priority of Support section below the map */}
      <div className="mt-4 px-4 pb-4" data-id="element-347">
        <PriorityOfSupport data-id="element-348" />
      </div>
    </div>;
};